import { render, staticRenderFns } from "./BadgeRenderer.vue?vue&type=template&id=635ce65e&scoped=true&"
import script from "./BadgeRenderer.vue?vue&type=script&lang=ts&"
export * from "./BadgeRenderer.vue?vue&type=script&lang=ts&"
import style0 from "./BadgeRenderer.vue?vue&type=style&index=0&id=635ce65e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635ce65e",
  null
  
)

export default component.exports